import { Field, Input, InputGroup } from '@chakra-ui/react'
import { FormErrors } from 'commons/components/layout/FormErrors'
import { Label } from 'commons/components/layout/Label'
import { Section } from 'commons/components/layout/Section'
import { BgColors, TextColors } from 'commons/design-system/tokens'
import { FormStep } from 'commons/types/paymentTypes'
import type { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

type CitySectionProps = {
	errors: {
		city?: string
	}
	isLoading: boolean
	step: FormStep
	isReadOnly: boolean
	city: string
	onCityChange?: (value: string) => void | undefined
	onClearError?: (field: 'city') => void | undefined
}

export const CitySection = ({
	errors,
	isLoading,
	step,
	isReadOnly,
	city,
	onCityChange,
	onClearError
}: CitySectionProps) => {
	const { t } = useTranslation()
	const getBorder = (isError: boolean) =>
		isError ? `1px solid ${TextColors.STATUS_ERROR}` : `1px solid ${BgColors.Z3}`
	return (
		<Field.Root invalid={!!errors.city}>
			<Section px={0} pt={2} pb={0}>
				<Label>{t('phone_form.verify_identity_manual_city_label')}</Label>
				<InputGroup>
					<Input
						name='city'
						autoComplete='address-level2'
						type='text'
						mt={2}
						fontFamily='Montserrat'
						fontWeight='500'
						border={getBorder(!!errors.city)}
						borderRadius='6px'
						py={2}
						value={city}
						onChange={(e: ChangeEvent<HTMLInputElement>) => {
							onCityChange?.(e.target.value)
							if (errors.city) {
								onClearError?.('city')
							}
						}}
						_focus={{ outline: 'none', borderColor: 'blue.500', boxShadow: 'none' }}
						_focusVisible={{ outline: 'none', borderColor: 'blue.500', boxShadow: 'none' }}
						disabled={isLoading || step === FormStep.STEP_BIRTHDATE || isReadOnly}
						readOnly={isReadOnly}
						bg={isReadOnly ? BgColors.Z4 : BgColors.Z5}
					/>
				</InputGroup>
				{errors.city && <FormErrors withoutBorder errors={[errors.city]} />}
			</Section>
		</Field.Root>
	)
}
